import { render, staticRenderFns } from "./StaffAdminPageTable.vue?vue&type=template&id=cfac9cb6&scoped=true&"
import script from "./StaffAdminPageTable.vue?vue&type=script&lang=js&"
export * from "./StaffAdminPageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfac9cb6",
  null
  
)

export default component.exports